import { takeLatest, call, put } from 'redux-saga/effects'
import answerTaskDestroy from 'api/answers/task/Destroy'
import * as fromActions from '../../../actions/answer-task.action'
import * as fromLessionsActions from '../../../actions/lessons.action'

async function handleDestroy(fileId: string) {
  return await answerTaskDestroy(fileId)
}

function* destroyTaskEffectSaga(action: any) {
  try {
    const { payload } = action
    const { index, token } = payload
    yield call(handleDestroy, token)
    yield put(fromActions.Actions.answerTaskDeleteSuccess())
    yield put(
      fromLessionsActions.Actions.lessonsRemoveAttachmentTask({
        index,
        token,
      })
    )
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* destroyTaskAnswerWatcherSaga() {
  yield takeLatest(fromActions.ANSWER_TASK_DELETE, destroyTaskEffectSaga)
}
